"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzCustomToastContainer = void 0;
const react_1 = __importStar(require("react"));
const Toast_1 = __importDefault(require("./Toast"));
exports.VbzCustomToastContainer = ({ id, messages = [], single = true, timer = 0, position = 'center', removeToast, }) => {
    const [allMessages, setAllMessages] = react_1.useState(() => {
        if (single && messages[0]) {
            return [messages[0]];
        }
        return messages;
    });
    react_1.useEffect(() => {
        if (single && messages[0])
            setAllMessages([messages[0]]);
        else
            setAllMessages(messages);
    }, [messages]);
    return (react_1.default.createElement("div", { id: id, className: "vbz-custom-toast-container" }, allMessages.map((item) => (react_1.default.createElement(Toast_1.default, { key: item.id, message: item, className: `float-${position}`, removeToast: removeToast, timer: timer > 1000 ? timer : 7000 })))));
};
//# sourceMappingURL=index.js.map